export default __webpack_public_path__ + "static/media/hdpe-drum-bales-hdpe-cans-2.ad9b31f5.jpg";